import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m24.601 39.457 8.755-17.51-6.957-.695a1.91 1.91 0 0 1-1.61-2.535L29.213 6.18a.955.955 0 0 0-.9-1.272h-9.047a.955.955 0 0 0-.942.798l-2.876 17.255a2.864 2.864 0 0 0 2.565 3.323l5.483.498a1.91 1.91 0 0 1 1.733 2.013L24.6 39.457Zm-.372 5.013c-.464.929-1.867.554-1.806-.483l.9-15.303-5.482-.498a4.773 4.773 0 0 1-4.276-5.538l2.876-17.255A2.864 2.864 0 0 1 19.266 3h9.047a2.863 2.863 0 0 1 2.7 3.817L26.59 19.352l6.957.696a1.909 1.909 0 0 1 1.518 2.753L24.23 44.471Z",
      clipRule: "evenodd"
    }
  )
);
var SvgActivityOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ActivityOutlined_default = SvgActivityOutlined;

export { ActivityOutlined_default as default };
